angular.module('bb.appointments').config(appointmentsRoutes);

appointmentsRoutes.$inject = ['$routeProvider'];
function appointmentsRoutes($routeProvider) {
  $routeProvider
    .when('/appointments/:appointmentId/action', {
      template: '<bb-appointment-action />',
    })
    .when('/appointments/:appointmentId/deny', {
      template: '<bb-appointment-deny />',
    })
    .when('/appointments/:appointmentId/cancel', {
      template: '<bb-appointment-cancel />',
    })
    .when('/appointments/:appointmentId/confirm', {
      template: '<bb-appointment-confirm />',
    })
    .when('/listing/:listingId/appointments', {
      template: '<bb-appointment-list />',
    })

    .when('/listing/:listingId/appointments/config', {
      template: '<bb-appointment-config />',
    })
    .when('/appointments/:appointmentId/status/:status', {
      template: '<bb-appointment-status-change />',
    })
    .when('/listing/:listingId/appointments/book', {
      template: '<appointment-book />',
    })
    .when('/appointments/:appointmentId/time_change', {
      template: `<bb-appointment-time-change />`,
    })
    .when('/appointments/:appointmentId/time_change_contact', {
      template: `<bb-appointment-time-change is-listing-contact="true" />`,
    })
    .when('/listing/:listingId/tour/:tourId/details', {
      template: `<bb-virtual-tour-details />`,
    });
}

export {};
